import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export function setupIcons(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
    // https://www.npmjs.com/package/@mdi/angular-material
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg'));

    // kempower custom icons
    matIconRegistry.addSvgIcon(
        'ev-station-alt',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/station.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-cabinet-small',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/cabinet-small.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-cabinet-large',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/cabinet-large.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-trolley-small',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/trolley-small.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-satellite',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/satellite.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-temperature',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/k-temperature.svg')
    );
    matIconRegistry.addSvgIcon('k-ccs', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/conn-ccs2.svg'));
    matIconRegistry.addSvgIcon(
        'k-chademo',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/conn-chademo.svg')
    );
    matIconRegistry.addSvgIcon('k-ac', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/conn-ac.svg'));
    matIconRegistry.addSvgIcon('k-ev', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/EV.svg'));
    matIconRegistry.addSvgIcon('k-pmc', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/pmc.svg'));
    matIconRegistry.addSvgIcon('k-session', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/session.svg'));
    matIconRegistry.addSvgIcon(
        'k-connector',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/connector.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-car-limit',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/car-limit.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-charger-limit',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/charger-limit.svg')
    );
    matIconRegistry.addSvgIcon('k-charger', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/charger.svg'));
    matIconRegistry.addSvgIcon(
        'k-grid-limit',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/grid-limit.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-shared-limit',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/shared-limit.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-queue-limit',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/queue-limit.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-cabinet-cabling',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/cabinet-cabling.svg')
    );
    matIconRegistry.addSvgIcon('k-nacs', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/conn-nacs.svg'));
    matIconRegistry.addSvgIcon('k-mcs', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/conn-mcs.svg'));
    matIconRegistry.addSvgIcon(
        'k-movable-charging',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/movable_charging.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-charging-satellite',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/charging_satellite.svg')
    );
    matIconRegistry.addSvgIcon('k-play', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/k-play.svg'));
    matIconRegistry.addSvgIcon('k-stop', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/k-stop.svg'));

    /**
     * System health dashboard images as icons
     * */
    matIconRegistry.addSvgIcon(
        'k-health-charger',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/system-health-dashboard/charger.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-health-chargeye',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/system-health-dashboard/chargeye.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-health-cloud',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/system-health-dashboard/cloud.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-health-vehicles',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/system-health-dashboard/vehicles.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-health-browser',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/system-health-dashboard/browser.svg')
    );
    matIconRegistry.addSvgIcon(
        'k-health-full',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/system-health-dashboard/full.svg')
    );

    // carbon design system icons - https://carbondesignsystem.com/elements/icons/library/
    matIconRegistry.addSvgIcon(
        'c-settings',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/settings.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-configuration',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/station-config.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-information',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/information.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-dashboard',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/dashboard.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-location',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/location.svg')
    );
    matIconRegistry.addSvgIcon('c-play', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/play.svg'));
    matIconRegistry.addSvgIcon(
        'c-skip-back',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/skip--back.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-skip-forward',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/skip--forward.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-zoom-reset',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/zoom--reset.svg')
    );
    matIconRegistry.addSvgIcon('c-zoom-in', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/zoom--in.svg'));
    matIconRegistry.addSvgIcon(
        'c-zoom-out',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/zoom--out.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-maximize',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/maximize.svg')
    );
    matIconRegistry.addSvgIcon('c-report', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/report.svg'));
    matIconRegistry.addSvgIcon(
        'c-report-check',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/report-check.svg')
    );
    matIconRegistry.addSvgIcon('c-task', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/task.svg'));
    matIconRegistry.addSvgIcon('c-filter', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/filter.svg'));
    matIconRegistry.addSvgIcon(
        'c-filter-remove',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/filter-remove.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-customer',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/enterprise.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-connection-signal',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/connection-signal.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-connection-signal-off',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/connection-signal-off.svg')
    );
    matIconRegistry.addSvgIcon('c-launch', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/launch.svg'));
    matIconRegistry.addSvgIcon('c-flash', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/flash.svg'));
    matIconRegistry.addSvgIcon('c-bus', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/bus.svg'));
    matIconRegistry.addSvgIcon(
        'c-cloud-monitor',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/cloud--monitoring.svg')
    );
    matIconRegistry.addSvgIcon('c-email', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/email.svg'));
    matIconRegistry.addSvgIcon(
        'c-check-circle',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/checkmark--outline.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-cross-circle',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/misuse--outline.svg')
    );
    matIconRegistry.addSvgIcon('c-dot', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/dot-mark.svg'));
    matIconRegistry.addSvgIcon(
        'c-warning',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/warning--alt.svg')
    );
    matIconRegistry.addSvgIcon(
        'c-invalid',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/error--outline.svg')
    );
    matIconRegistry.addSvgIcon('c-reset', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/reset.svg'));
    matIconRegistry.addSvgIcon('screen', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/screen.svg'));
    matIconRegistry.addSvgIcon(
        'c-asset',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/app-connectivity.svg')
    );
    matIconRegistry.addSvgIcon('c-search', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/search.svg'));

    // material.io icons - https://material.io/resources/icons/?style=baseline
    matIconRegistry.addSvgIcon(
        'm-arrow-left',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/arrow-left.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-arrow-right',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/arrow-right.svg')
    );
    matIconRegistry.addSvgIcon('m-more', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/more.svg'));
    matIconRegistry.addSvgIcon(
        'm-edit-off',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/m-edit-off.svg')
    );

    // material design icons - https://materialdesignicons.com/
    matIconRegistry.addSvgIcon('m-cookie', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/cookie.svg'));
    matIconRegistry.addSvgIcon(
        'm-construction',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/construction.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-visibility',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/visibility.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-insights',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/insights.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-view-grid',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/view-grid.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-view-list',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/view-list.svg')
    );
    matIconRegistry.addSvgIcon('close', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/close.svg'));
    matIconRegistry.addSvgIcon('m-key', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/key.svg'));
    matIconRegistry.addSvgIcon(
        'm-calendar-edit',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/calendar-edit.svg')
    );
    matIconRegistry.addSvgIcon('m-monitor', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/monitor.svg'));
    matIconRegistry.addSvgIcon(
        'm-image-plus-outline',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/image-plus-outline.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-arrow-left',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/arrow-left.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-arrow-right',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/arrow-right.svg')
    );
    matIconRegistry.addSvgIcon('m-clock', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/clock.svg'));
    matIconRegistry.addSvgIcon('m-star', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/star.svg'));
    matIconRegistry.addSvgIcon('m-finance', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/finance.svg'));
    matIconRegistry.addSvgIcon(
        'm-ev-station',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/ev-station.svg')
    );
    matIconRegistry.addSvgIcon('m-import', domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/import.svg'));
    matIconRegistry.addSvgIcon(
        'm-border-radius',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/border-radius.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-car-tubocharger',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/car-turbocharger.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-file-tree',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/file-tree.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-selection',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/selection.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-package',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/package-variant-closed.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-boom-gate',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/boom-gate-up-outline.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-puzzle',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/puzzle-outline.svg')
    );
    matIconRegistry.addSvgIcon(
        's-clock',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/clock-time-seven.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-alert-circle',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/alert-circle.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-alert-circle-outline',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/alert-circle-outline.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-help-circle-outline',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/help-circle-outline.svg')
    );
    matIconRegistry.addSvgIcon(
        'm-help-box-outline',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/help-box-outline.svg')
    );
    matIconRegistry.addSvgIcon(
        'error-severity-error',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/alert-rhombus.svg')
    );
    matIconRegistry.addSvgIcon(
        'error-severity-warning',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/alert.svg')
    );

    // UI times - Chargers in different timezones - https://kempower.atlassian.net/browse/KC-2555
    matIconRegistry.addSvgIcon(
        'browser-time',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/browser-time.svg')
    );
    matIconRegistry.addSvgIcon(
        'time-icon',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/time-icon.svg')
    );

    matIconRegistry.addSvgIcon(
        'm-error-code',
        domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/emergency_home.svg')
    );
}
